var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "formInput__wrapper" }, [
    _c(
      "label",
      {
        staticClass: "formCheckbox",
        class: _vm.checkboxLarge ? "formCheckbox--large" : null,
        attrs: { for: _vm.fieldId },
      },
      [
        _c("span", { staticClass: "formCheckbox__inputWrapper" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.fieldChecked,
                expression: "fieldChecked",
              },
            ],
            ref: _vm.fieldId,
            staticClass: "formCheckbox__input",
            class: _vm.fieldClasses,
            attrs: {
              id: _vm.fieldId,
              type: "checkbox",
              name: _vm.fieldName,
              required: _vm.fieldRequired,
              disabled: _vm.fieldDisabled,
              "aria-invalid": `${_vm.ariaInvalidStatus}`,
              "aria-checked": _vm.fieldChecked ? _vm.fieldChecked : "false",
              "data-gtm": _vm.dataGtm,
            },
            domProps: {
              value: _vm.fieldValue,
              checked: Array.isArray(_vm.fieldChecked)
                ? _vm._i(_vm.fieldChecked, _vm.fieldValue) > -1
                : _vm.fieldChecked,
            },
            on: {
              change: [
                function ($event) {
                  var $$a = _vm.fieldChecked,
                    $$el = $event.target,
                    $$c = $$el.checked ? true : false
                  if (Array.isArray($$a)) {
                    var $$v = _vm.fieldValue,
                      $$i = _vm._i($$a, $$v)
                    if ($$el.checked) {
                      $$i < 0 && (_vm.fieldChecked = $$a.concat([$$v]))
                    } else {
                      $$i > -1 &&
                        (_vm.fieldChecked = $$a
                          .slice(0, $$i)
                          .concat($$a.slice($$i + 1)))
                    }
                  } else {
                    _vm.fieldChecked = $$c
                  }
                },
                _vm.handleChange,
              ],
            },
          }),
        ]),
        _vm._v(" "),
        _c(
          "span",
          { staticClass: "formCheckbox__labelText" },
          [
            _vm.fieldLabel && !_vm.labelCustomId
              ? _c("span", { domProps: { innerHTML: _vm._s(_vm.fieldLabel) } })
              : _c("span", {
                  domProps: { innerHTML: _vm._s(_vm.labelCustomText) },
                }),
            _vm._v(" "),
            _vm._t("default"),
            _vm._v(" "),
            _vm.fieldRequired === true
              ? _c("span", { staticClass: "formCheckbox__required" }, [
                  _vm._v("*\n                "),
                  _c("span", { staticClass: "visually-hidden" }, [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.trans("LABEL_TEXT_SR_REQUIRED")) +
                        "\n                "
                    ),
                  ]),
                ])
              : _vm._e(),
          ],
          2
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }